import React from 'react'

import { PersonAvatar, WorkspaceLogo } from '@sketch/components'
import { WorkspaceInviteAcceptedNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import { GoToWorkspaceAction } from './InboxPreviewActions'
import {
  Card,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface WorkspaceInviteAcceptedPreviewProps {
  notification: WorkspaceInviteAcceptedNotificationFragment
}

export const WorkspaceInviteAcceptedPreview = ({
  notification,
}: WorkspaceInviteAcceptedPreviewProps) => {
  const { user, workspace, title } = notification

  const inviteeName = user?.name ?? 'Someone'
  const inviteeAvatar = user?.avatar?.small
  const workspaceName = workspace?.name ?? title

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {inviteeAvatar ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={inviteeName}
                src={inviteeAvatar}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={inviteeName} />
            )}
          </AvatarWrapper>
          <TileTitle>{inviteeName}</TileTitle>
          <TileMeta>Invitee</TileMeta>
        </Tile>

        <Separator />

        <Tile>
          <AvatarWrapper>
            <WorkspaceLogo
              size="96px"
              workspaceName={workspaceName}
              src={workspace?.avatar?.small}
            />
          </AvatarWrapper>
          <TileTitle>{workspaceName}</TileTitle>
          <TileMeta>Workspace</TileMeta>
        </Tile>
      </TileWrapper>

      {workspace && <GoToWorkspaceAction workspaceId={workspace.identifier} />}
    </Card>
  )
}
